import { useState } from 'react';
import api from '../../../../api/api';

export const useApartmentData = () => {
  const [apartments, setApartments] = useState({});
  const [guests, setGuests] = useState({});

  const fetchApartmentsForGuest = async () => {
    try {
      const response = await api.get('/properties/apartments/');
      const apartmentsData = response.data;
      
      const apartmentsMap = {};
      apartmentsData.forEach(apartment => {
        apartmentsMap[apartment.id] = apartment.apartment_name;
      });
      setApartments(apartmentsMap);
    } catch (error) {
      console.error("Error fetching apartments for guest:", error);
    }
  };

  const fetchOwnerApartments = async (ownerId) => {
    try {
      const response = await api.get(`/properties/apartments/?owner=${encodeURIComponent(ownerId)}`);
      const apartmentsData = response.data;
      
      const apartmentsMap = {};
      apartmentsData.forEach(apartment => {
        apartmentsMap[apartment.id] = apartment.apartment_name;
      });
      setApartments(apartmentsMap);
      
      return apartmentsData; // Return for use in other hooks
    } catch (error) {
      console.error("Error fetching owner apartments:", error);
      return [];
    }
  };

  const fetchGuestDetails = async (guestIds) => {
    try {
      const guestDetails = await Promise.all(
        guestIds.map(async (guestId) => {
          const response = await api.get(`/users/groups/guests/${encodeURIComponent(guestId)}/`);
          return response.data;
        })
      );

      const guestsMap = {};
      guestDetails.forEach(guest => {
        guestsMap[guest.id] = guest.username;
      });
      setGuests(guestsMap);
    } catch (error) {
      console.error("Error fetching guest details:", error);
    }
  };

  return {
    apartments,
    guests,
    setApartments,
    setGuests,
    fetchApartmentsForGuest,
    fetchOwnerApartments,
    fetchGuestDetails
  };
};